import { useState } from 'react'
import { HiCreditCard } from 'react-icons/hi'
import Tooltip from '../Tooltip'

import * as S from './styles'

const TextField = ({
  reference,
  name,
  label,
  labelFor = '',
  initialValue = '',
  maxlength = 25,
  onInput,
  required = false,
  disabled = false,
  success = false,
  error,
  type = 'text',
  tooltip,
  tooltipText = '',
  pattern,
  image,
  pedidoNegado,
  ...props
}) => {
  const [value, setValue] = useState(initialValue)

  const onChange = (e) => {
    const newValue = e.currentTarget.value
    setValue(newValue)

    !!onInput && onInput(newValue)
  }

  return (
    <S.Wrapper
      disabled={disabled}
      error={!!error}
      success={success}
      required={required}
      tooltip
      tooltipText
    >
      {!!label && <S.Label htmlFor={labelFor}>{label}</S.Label>}
      <S.InputWrapper>
        <div
          style={image && { display: 'flex', justifyContent: 'space-between' }}
        >
          <S.Input
            ref={reference}
            maxLength={maxlength}
            type={type}
            disabled={disabled}
            onChange={onChange}
            value={value}
            name={name}
            pattern={pattern}
            {...props}
          />
          {image}
        </div>

        {tooltip && (
          <Tooltip
            icon={<i className="icon icon-info"></i>}
            message={tooltipText}
            left
          />
        )}
      </S.InputWrapper>
      {!!error && (
        <S.Error className={!!pedidoNegado ? 'pedido-negado' : ''}>
          {error}
        </S.Error>
      )}
    </S.Wrapper>
  )
}

export default TextField
